<template>
    <el-card>
        <div slot="header" class="clearfix">
            <span>动态</span>
            <PowerSelect defaultText="仅我的动态" @onChoose="onChoose" />
            <div class="rightHandle">
                <el-input v-model="filterParam.content" placeholder="内容" size="small" @keyup.enter.native="toSearch" style="width: 200px;"></el-input>
                <el-date-picker v-model="filterParam.beginTime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="small" @change="toSearch" style="width: 160px;"></el-date-picker>
                <el-date-picker v-model="filterParam.endTime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" size="small" @change="toSearch" :clearable="false" style="width: 160px;"></el-date-picker>
            </div>
        </div>
        <div v-loading="tableLoading">
            <el-empty v-if="totalItems==0" description="暂无数据" style="height:calc(100vh - 300px);"></el-empty>
            <el-table v-else :data="dynamicList" style="width:100%;" height="calc(100vh - 300px)" size="small">
                <el-table-column prop="contactPerson" label="联系人" width="150px"></el-table-column>
                <el-table-column prop="followContent" label="跟进内容" min-width="200px" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-html="scope.row.followContent"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="followTime" label="跟进时间" width="150px"></el-table-column>
                <el-table-column prop="followType" label="跟进类型" width="150px"></el-table-column>
                <el-table-column prop="follower" label="跟进人" width="150px">
                    <template slot-scope="scope">
                        <el-popover trigger="hover">
                            <ColleageCard v-if="scope.row.card2Show" :ckey="scope.row.followerKey" />
                            <div slot="reference" @mouseenter="hoverCard(scope.row,2)">{{scope.row.follower}}</div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column prop="nextFollowTime" label="下次跟进时间" width="150px"></el-table-column>
                <el-table-column label="附件" width="150px">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" v-if="scope.row.annex.length > 0" @click="viewAnnex(scope.row.annex)">查看</el-button>
                        <span v-else>暂无附件</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="totalItems!==0">
                <el-pagination background layout="total,sizes,prev,pager,next" :page-sizes="[10, 20, 40]" :page-size.sync="pageSize" @size-change="pageSizeChange" :total="totalItems" :current-page.sync="pageIndex" @current-change="pageIndexChange"></el-pagination>
            </div>
        </div>
        
        <el-dialog title="附件" :visible.sync="viewAnnexVisible" width="500px">
            <div v-for="(row,index) in annexList" :key="index" style="display:inline-block;margin-right:10px;">
                <div v-if="isImageFile(row.name)">
                    <el-image style="width: 60px; height: 60px" :src="row.url" :preview-src-list="[row.url]" />
                    <div>{{row.name}}</div>
                </div>
                <el-link type="primary" v-else :href="row.url" :underline="false" target="_blank">{{row.name}}</el-link>
            </div>
            <div slot="footer">
                <el-button type="primary" @click="viewAnnexVisible = false" size="small">确 定</el-button>
            </div>
        </el-dialog>

    </el-card>
</template>

<script>
import dayjs from "dayjs";
import ContactCard from "@/components/ContactCard.vue";
import ColleageCard from "@/components/ColleageCard.vue";
import PowerSelect from "@/components/PowerSelect.vue";
export default {
    components: { ContactCard , ColleageCard, PowerSelect },
    data() {
        return {
            organizationKey: "",
            salekey: "",
            // 过滤字段
            filterParam: {
                "customerName": "",
                "content": "",
                "beginTime": dayjs().startOf('month').format('YYYY-MM-DD'),
                "endTime": dayjs().endOf('month').format('YYYY-MM-DD'),
            },
            //列表展示
            tableLoading: false,
            dynamicList: [],
            totalItems: 0,
            pageIndex: 1,
            pageSize: 10,
            //附件
            viewAnnexVisible: false,
            annexList: [],
        };
    },
    methods: {
        hoverCard(row,type){
            if(type == 1){ row.card1Show = true;}
            if(type == 2){ row.card2Show = true;}
            if(type == 3){ row.card3Show = true;}
        },
        onChoose(valueOne,valueTwo){
            this.organizationKey = valueOne;
            this.salekey = valueTwo;
            this.toSearch();
        },
        //获取动态
        getDynamic(){
            const {beginTime,endTime,customerName,content} = this.filterParam;
            this.tableLoading = true;
            this.$axios.post(`${this.$customerUrl}/AdvertisingForm/FollowRecordList`,{
                beginTime,endTime,customerName,content,type: "",
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                organizationKey: this.organizationKey,
                ukey: this.salekey,
            }).then((res) => {
                const { isSuccess , data } = res;
                this.tableLoading = false;
                if (isSuccess) {
                    this.dynamicList = data.datas.map(item=>({
                        ...item,
                        card1Show: false,
                        card2Show: false,
                        card3Show: false,
                    }))
                    this.totalItems = data.totalItems;
                }
            });
        },
        pageIndexChange(page) {
            this.pageIndex = page;
            this.getDynamic();
        },
        pageSizeChange() {
            this.pageIndex = 1;
            this.getDynamic();
        },
        toSearch(){
            this.pageIndex = 1;
            this.getDynamic();
        },

        //判断是否为图片文件
        isImageFile(fileName) {
            return ["png", "jpg", "jpeg"].includes(fileName.substring(fileName.lastIndexOf(".") + 1));
        },
        //查看附件内容
        viewAnnex(annex){
            this.viewAnnexVisible = true;
            this.annexList = annex;
        },


    },
    mounted() {
        this.getDynamic();    //获取动态列表
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-card__header{
    padding: 10px 20px;
}

.clearfix{
    height: 32px;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
}

.rightHandle{
    display: flex;
    gap: 10px;
    margin-left: auto;
}

.pagination{
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
}
</style>